import { AccessibilityHelper } from '../GlobalAssets/js/accessibilityHelper';

class ContactForms {
  constructor(component) {
    this.refs = {
      formSelect: '.js-form-select',
      formToggle: '.js-form-toggle',
      formContainer: '.js-form-container',
    };

    this.dom = {
      $component: component,
      $formSelect: component.querySelector(this.refs.formSelect),
      $formToggles: component.querySelectorAll(this.refs.formToggle),
      $formContainers: component.querySelectorAll(this.refs.formContainer),
    };

    this.state = {
      activeTabIndex: 0,
      accessibilityHelper: new AccessibilityHelper(),
    };

    this.init();

    this.mount();
  }


  init() {
    console.log('ContactForms init');
  }

  mount() {
    const { dom } = this;

    if (!dom.$formSelect || !dom.$formToggles.length || !dom.$formContainers.length) {
      return;
    }

    console.log('ContactForms mounted');

    dom.$formToggles.forEach(($toggle, index) => {
      $toggle.addEventListener('click', () => {
        this.activateTab(index);
      });

      $toggle.addEventListener('keydown', (e) => {
        this.handleTabKeydown(e, index);
      });
    });

    dom.$formSelect.addEventListener('change', this.formSelectChange.bind(this));

    this.updateTabpanelAccessibility(0);
    this.observeFormContainers();
  }

  observeFormContainers() {
    const { dom } = this;

    this.mutationObserver = new MutationObserver(() => {
      const allLoaded = [...dom.$formContainers].every(
        ($container) => $container.querySelector('.hs-form')
      );

      if (allLoaded) {
        this.mutationObserver.disconnect();
        this.updateTabpanelAccessibility(this.state.activeTabIndex);
      }
    });

    dom.$formContainers.forEach(($container) => {
      this.mutationObserver.observe($container, { childList: true, subtree: true });
    });
  }

  activateTab(index, moveFocus = true) {
    const { dom } = this;
    this.state.activeTabIndex = index;
    const selectedIndex = String(index);

    // Update toggle states
    dom.$formToggles.forEach(($btn, i) => {
      const isActive = i === index;
      $btn.classList.toggle('is-active', isActive);
      $btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      $btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update select to match
    dom.$formSelect.value = selectedIndex;

    // Show the corresponding form and hide others
    dom.$formContainers.forEach($container => {
      if ($container.dataset.formIndex === selectedIndex) {
        $container.classList.add('is-active');
      } else {
        $container.classList.remove('is-active');
      }
    });

    if (moveFocus) {
      dom.$formToggles[index].focus();
    }
    this.updateTabpanelAccessibility(index);
  }

  handleTabKeydown(e, currentIndex) {
    const { dom } = this;
    const lastIndex = dom.$formToggles.length - 1;
    let newIndex;

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        newIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        this.activateTab(newIndex);
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        newIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        this.activateTab(newIndex);
        break;
      case 'Home':
        e.preventDefault();
        this.activateTab(0);
        break;
      case 'End':
        e.preventDefault();
        this.activateTab(lastIndex);
        break;
    }
  }

  updateTabpanelAccessibility(activeIndex) {
    const { dom, state } = this;

    dom.$formContainers.forEach(($formContainer, index) => {
      const isActive = index === activeIndex;
      $formContainer.setAttribute('aria-hidden', !isActive);
      state.accessibilityHelper.updateElementAccessibility($formContainer, isActive);
    });
  }

  formSelectChange(e) {
    const selectedIndex = parseInt(e.currentTarget.value, 10);
    this.activateTab(selectedIndex, false);
  }
}

document.querySelectorAll('.js-contact-forms').forEach(
  ($el) => new ContactForms($el)
);
